import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Button } from './ui/Button';
export function HeroSection() {
  return <SectionWrapper className="pt-32 md:pt-40 pb-24 md:pb-32 text-center" data-id="element-53">
      <div className="space-y-8" data-id="element-54">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight text-primary" data-id="element-55">
          Ya No me Habla: <br className="hidden md:block" data-id="element-56" />
          <span className="text-amber font-normal italic" data-id="element-57">
            El Protocolo para Recuperar a tu Hijo Adolescente
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-secondary font-body max-w-2xl mx-auto leading-relaxed" data-id="element-58">
          (Sin Gritos ni Portazos)
        </p>

        <div className="w-16 h-px bg-amber mx-auto my-8 opacity-50" data-id="element-59"></div>

        <h2 className="text-lg md:text-xl text-primary font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-60">
          La guía práctica para padres agotados que sienten que han perdido el
          acceso al mundo de sus hijos.
        </h2>

        <div className="pt-4" data-id="element-61">
          <a href="#oferta" onClick={e => {
          e.preventDefault();
          document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-62">
            <Button className="text-base md:text-lg px-10 py-5" data-id="element-63">
              QUIERO RECUPERAR LA COMUNICACIÓN CON MI HIJO
            </Button>
          </a>
        </div>

        <div className="pt-8" data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/1y5frvKR8A1ur22ACyKtTh/heylloyd-image-1774042119761_Ya_no_me_habla_6.png" alt="Portada del libro Ya No me Habla en una tablet" className="w-full max-w-lg mx-auto rounded-sm shadow-warm-lg" data-id="element-65" />
        </div>
      </div>
    </SectionWrapper>;
}